import { render, staticRenderFns } from "./DialogBrowserRecommend.vue?vue&type=template&id=d49ce0f4&scoped=true&"
import script from "./DialogBrowserRecommend.vue?vue&type=script&lang=js&"
export * from "./DialogBrowserRecommend.vue?vue&type=script&lang=js&"
import style0 from "./DialogBrowserRecommend.vue?vue&type=style&index=0&id=d49ce0f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49ce0f4",
  null
  
)

export default component.exports